import { DeviationStatus } from "./DeviationStatus";
import { DeviationType } from "./DeviationType";
export const DeviationHelp = {
	IK_mat: "IK_mat",
	Snu_pall: "Snu_pall",
	Bytt_pall: "Bytt_pall",
	Temp_kontroll: "Temp_kontroll",
	Varsle_destruksjon: "Varsle_destruksjon",
	Sett_til_side: "Sett_til_side",
};

// {
//     "IK-mat": "Snur og om det er brudd på IK-mat destrueres fisken -> modulen",
//     "Snu pall": "Paller snus og plastres -> kunde varsles -> belastes kunde m/snu pall",
//     "Bytt pall": "Løfter opp og bytter pall",
//     "Temp kontroll": "Temp kontroll tas i luft på tralle og mellom bokser. Mellom første, mellomste og siste pall",
//     "Varsle destruksjon": "Kunde må varsles og sjekkes av med om den skal destrueres",
//     "Sett til side": "Settes til side. Sjekkes mot lister. Merkes med pallenummer og kg"
// };

export const deviationHelpByLevelAndType = {
	employee: {
		[DeviationType.poor_load_securing]: DeviationHelp.IK_mat,
		[DeviationType.broken_boxes]: DeviationHelp.Bytt_pall,
		[DeviationType.damaged_pallet]: DeviationHelp.Bytt_pall,
		[DeviationType.frozen_pallets]: DeviationHelp.Bytt_pall,
		[DeviationType.tipped_over_pallet]: DeviationHelp.Bytt_pall,
		[DeviationType.temperature_deviation]: DeviationHelp.Temp_kontroll,
		[DeviationType.missing_label]: DeviationHelp.Varsle_destruksjon,
		[DeviationType.out_of_date]: DeviationHelp.Varsle_destruksjon,
		[DeviationType.pallet_found_should_been_sent]: DeviationHelp.Varsle_destruksjon,
		[DeviationType.other]: DeviationHelp.Varsle_destruksjon,
	},
	floor_manager: {
		[DeviationType.poor_load_securing]: DeviationHelp.Snu_pall,
		[DeviationType.broken_boxes]: DeviationHelp.Snu_pall,
		[DeviationType.damaged_pallet]: DeviationHelp.Snu_pall,
		[DeviationType.frozen_pallets]: DeviationHelp.Snu_pall,
		[DeviationType.tipped_over_pallet]: DeviationHelp.Snu_pall,
		[DeviationType.missing_label]: DeviationHelp.Sett_til_side,
	},
	management: {
		[DeviationType.poor_load_securing]: DeviationHelp.Snu_pall,
		[DeviationType.broken_boxes]: DeviationHelp.Snu_pall,
		[DeviationType.damaged_pallet]: DeviationHelp.Snu_pall,
		[DeviationType.frozen_pallets]: DeviationHelp.Snu_pall,
		[DeviationType.tipped_over_pallet]: DeviationHelp.Snu_pall,
		[DeviationType.missing_label]: DeviationHelp.Sett_til_side,
	},
};

export const deviationHelpByStatusAndType = {
	// employee
	[undefined]: deviationHelpByLevelAndType.employee,
	[DeviationStatus.OPEN]: deviationHelpByLevelAndType.employee,
	// floor manager
	[DeviationStatus.FIRST_AT_MANAGER]: deviationHelpByLevelAndType.floor_manager,
	[DeviationStatus.AT_MANAGER]: deviationHelpByLevelAndType.floor_manager,
	// management
	[DeviationStatus.COULD_CLAIM]: deviationHelpByLevelAndType.management,
	[DeviationStatus.COULD_LOSS]: deviationHelpByLevelAndType.management,
	[DeviationStatus.COULD_NEGLIGENCE]: deviationHelpByLevelAndType.management,
	[DeviationStatus.AT_MANAGEMENT]: deviationHelpByLevelAndType.management,
};
